package ru.villawonka.app.presentation.screens.search.compose.layout

import androidx.compose.runtime.Composable
import ru.villawonka.app.presentation.screens.search.compose.SearchCallbacks
import ru.villawonka.app.presentation.screens.search.viewmodel.SearchResultsUIState
import ru.villawonka.app.presentation.screens.search.viewmodel.SearchUIState
import ru.villawonka.app.presentation.screens.search.viewmodel.SearchViewModel
import ru.villawonka.app.presentation.sharedviews.DefaultErrorStateLayout
import ru.villawonka.app.presentation.sharedviews.DefaultLoadingStateLayout

@Composable
fun SearchRootLayout(
    viewModel: SearchViewModel,
    searchState: SearchUIState,
    searchResultsState: SearchResultsUIState,
    callbacks: SearchCallbacks,
) {
    when (searchState) {
        is SearchUIState.Loading -> DefaultLoadingStateLayout()
        is SearchUIState.Error -> DefaultErrorStateLayout(
            failure = searchState.failure,
            onRetryClick = callbacks.onRetryButtonClick
        )
        is SearchUIState.Data -> SearchDataStateLayout(
            viewModel = viewModel,
            searchState = searchState,
            searchResultsState = searchResultsState,
            callbacks = callbacks,
        )
    }
}